<template>
	<v-app>
		<v-main>
			<router-view/>
		</v-main>
	</v-app>
</template>

<script>

export default {
	name: "App",
	data: () => ({
		//
	}),
};
</script>

<style>
/* standard color palette for JobBag */
.color-navy {
	color: #192A3E;
}

.color-purple {
	color: #CA66D2;
}

.color-purple-1 {
	color: #7C50A0;
}

.color-purple-2 {
	color: #C7B2D6;
}

.color-green {
	color: #BBE400;
}

.color-green-1 {
	color: #1AB26B;
}

.color-green-2 {
	color: #BDD96A;
}

.color-yellow {
	color: #FFD029;
}

.color-yellow-1 {
	color: #F68621;
}

.color-yellow-2 {
	color: #FFE94F;
}

.color-blue {
	color: #1FB7EE;
}

.color-blue-1 {
	color: #003E74;
}

.color-blue-2 {
	color: #4C9BCF;
}

.color-black {
	color: #192A3E;
}

.color-table-black {
	color: #394859;
}

.color-table-gray {
	color: #868B98;
}

.color-icon-gray {
	color: #AEBBCC;
}

/* positioning */
.hide_overflow {
	overflow: hidden;
}

.toolbar {
	background-color: white;
	padding: 5px !important;
}

.tile_header {
	border-radius: 4px 4px 0px 0px;
	color: white;
	background-color: #192A3E;
	padding-top: 3px;
	padding-bottom: 3px;
}

.tile_title {
	font-size: 16px;
	font-weight: 500;
	overflow: hidden;
}

.group_desc {
	padding-left: 5px;
	padding-right: 5px;

	font-size: 16px;
	font-weight: normal;
}

/* navigation */
.nav_tile_mobile {
	margin-bottom: 5px;
	padding: 5px;

	background-color: #FAFAFA;
}

.nav_disabled {
	opacity: 0.5;
}

/* special print stuff */
@media print {
	@page {
		/* size: 210mm 297mm;  */
		/* size: A4 landscape; */
		margin: 1.5em;
		size: portrait;
  }
	/* make sure our menu doesn't have space reserved when we print */
	.v-main {
		padding: 0 !important;

	}
	#main_container {
		background: white !important;
	}
	.v-data-table {
		border-radius: 0 !important;
	}

	.worklist-container {
		padding: 0 !important;
		width: 100% !important;
		height: 100% !important;
	}
	.perc_bar {
		position: absolute;
		top: 0px;
		left: 0px;
		height: 96% !important;
		z-index: 10;
		margin: 1px 0;
	}

	.toolbar {
		display: none;
	}
	.submit-claim {
		padding: 0 !important;
	}
	.list-receipts {
		padding: 0 !important;
	}
	.list-claim-table {
		margin: 0 !important;
		border: 1px solid rgba(0, 0, 0, 0.3);
		border-radius: 4px !important;
	}
	.list-approvals {
		background-color: #FFFFFF !important;
	}
}
</style>